import { useSortable } from '@dnd-kit/sortable';
import { Box, Typography } from '@mui/material';
import { Category } from '../../types/category';

interface DraggableCategoryProps {
  category: Category;
  index: number;
}

const DraggableCategory = ({ category, index }: DraggableCategoryProps) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: category.id!.toString() });

  const style = transform
    ? {
        transition: transition,
        opacity: isDragging ? 0.3 : 1,
        transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
        cursor: isDragging ? 'grabbing' : 'grab',
      }
    : undefined;

  return (
    <Box
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      style={style}
      display="flex"
      alignItems="center"
      gap={1}
      className="DraggableCategory"
    >
      <Typography color={'gray'}>{index + 1}</Typography>
      <Typography noWrap>{category.name}</Typography>
    </Box>
  );
};

export default DraggableCategory;
